import { Blocked } from './components/Blocked';
import { Composition } from './components/Composition';
import { InvestedAssets } from './components/InvestedAssets';
import { Liquidity } from './components/Liquidity';
import { RecommendedPortfolios } from './components/RecommendedPortfolios';
import { Strategy } from './components/Strategy';

export const financialDetailsTabs = [
  {
    key: 'composition',
    label: 'Ativos investidos',
    component: <InvestedAssets />,
  },
  {
    key: 'liquidity',
    label: 'Liquidez',
    component: <Liquidity />,
  },
  {
    key: 'strategy',
    label: 'Estratégia',
    component: <Strategy />,
  },
  {
    key: 'assets',
    label: 'Patrimônio',
    component: <Composition />,
  },
  {
    key: 'blocking',
    label: 'Bloqueado',
    component: <Blocked />,
  },
  {
    key: 'recommended-portfolios',
    label: 'Carteiras recomendadas',
    component: <RecommendedPortfolios />,
  },
];

export const financialDetailsInitialTab = 'composition';
